export enum MeetingType {
  ALL,
  ONE_ON_ONE,
  GROUP,
}
